import React, { useState, useEffect, Fragment } from 'react';
import { Alert, Table, Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../../util/Api';
import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../../app/slices/UserSlice';
import ProviderKeyForm from './ProviderKeyForm';
import { maskString } from '../../../util/ChartUtils';
//import { Formik } from 'formik';
//import * as Yup from 'yup';

/*
const validationSchema = Yup.object({
    apiKey: Yup.string().required('an api key is required'),
    providerId: Yup.string().required('a provider is required.')
});
*/
const ProviderKeyList = (props) => {

    const [errors, setErrors] = useState([]);
    const [successMsg, setSuccessMsg] = useState(null);
    const [providerKeys, setProviderKeys] = useState([]);
    const [showProviderKeyForm, setShowProviderKeyForm] = useState(false);
    //const [showEditForms, setShowEditForms] = useState([]);

    let { accountKey } = useParams();
    let navigate = useNavigate();

    //let showErrors = props?.showErrors === true ? true : false;

    //let userCount = props?.userCount ? props.userCount : 0;

    const currUserAccounts = useSelector(getUserAccounts);
    const currUserAccount = currUserAccounts.find(a => a.accountKey === accountKey);
    const currRoleId = currUserAccount ? currUserAccount.roleId : 0;
    //const userLimit = currUserAccount ? currUserAccount.userLimit : 0;

    const updateProviderKeys = (keys) => {
        //console.log('here in updateProviderKeys')
        //console.log('keys', keys);
        setErrors([])
        setSuccessMsg(null)
        //setShowEditForms(Array(keys.length).fill(false))
        setProviderKeys(keys);
    }

    const deleteProviderKey = (providerId) => {
        let options = {
            accountKey: accountKey,
            providerId: providerId
        }
        axios.post(apiUrl + '/providerkeys/delete',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    let temp = [...providerKeys];
                    temp = temp.filter(providerKey => providerKey.providerId !== providerId)
                    setProviderKeys(temp)
                    //console.log(temp)
                    //setShowEditForms(Array(providerKeys.length).fill(false))
                } else {
                    let errorMsgs = [];
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            default:
                                errorMsgs.push('There was an error deleting the provider key.');
                        }
                    });
                    setErrors(errorMsgs);
                }
            })
            .catch((err) => {

            });
    }

    const showEditForm = (idx) => {
        //const elem = e.currentTarget.nextSibling;
        const elem = document.getElementById(`edit-form-${idx}`)
        if (elem.className.indexOf('collapse show') > -1) {
            elem.classList.remove('show')
        } else {
            elem.classList.add('show')
            setSuccessMsg(null)
        }
    }

    const saveUpdate = (providerId, idx) => {
        let apiKey = document.getElementById(`apiKey-${idx}`) ? document.getElementById(`apiKey-${idx}`).value : null
        let secretKey = document.getElementById(`secretKey-${idx}`) ? document.getElementById(`secretKey-${idx}`).value : null
        let sessionToken = document.getElementById(`sessionToken-${idx}`) ? document.getElementById(`sessionToken-${idx}`).value : null

        let values = {
            accountKey: accountKey,
            providerId: providerId,
            apiKey: apiKey,
            secretKey: secretKey,
            sessionToken: sessionToken
        }

        setErrors([]);
        axios.post(apiUrl + '/providerkeys/update', values, { withCredentials: true })
            .then((res) => {
                if (res.data.status === "ok") {
                    setErrors([]);

                    //setSuccessMsg('The provider key was saved.')
                    //setProviderKeyFormVisible(false);
                    let temp = [...providerKeys]
                    let providerKey = res.data.providerKey;

                    //get original 
                    const provider = temp.find(p => p.providerId === providerKey.providerId)
                    //change 
                    Object.assign(provider, providerKey)

                    updateProviderKeys(temp);
                    setSuccessMsg('The provider key was updated.')
                    showEditForm(idx)
                }
                else {

                    let errorMsgs = [];

                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'no-permissions':
                                errorMsgs.push('You do not have permissions to edit provider keys.');
                                break;
                            case 'no-provider':
                                errorMsgs.push('Please select a provider');
                                break;
                            case 'no-keys':
                                errorMsgs.push('Please enter the key for the provider');
                                break;
                            default:
                                errorMsgs.push('There was an error updating the provider key.');
                        }
                    });
                    setErrors(errorMsgs);
                }
                //setSubmitting(false)
            })
            .catch((err) => {

                setErrors(['An error occurred while updating the provider key.']);
                //setSubmitting(false)
            });
    }

    useEffect(() => {

        if (currRoleId > 1) {
            setShowProviderKeyForm(true);
        }

        let options = {
            accountKey: accountKey
        }
        let isAuthError = false;
        axios.post(apiUrl + '/providerkeys/list',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    if (Array.isArray(res.data.providerKeys)) {
                        setProviderKeys(res.data.providerKeys);
                        //setShowEditForms(Array(providerKeys.length).fill(false))
                    }
                    else {
                        //nothing to show
                    }
                } else {
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                //navigate('/login');
                                //errorMsgs.push('You have been logged out.');
                                //return;
                                redirectToLogin = true;
                                break;
                            case 'no-results':
                                //console.log('no results')
                                errorMsgs.push('There are currently no Gen AI provider API keys. Add a provider to use the benchmarking and experimentation tools.');
                                break;
                            default:
                                errorMsgs.push('There was an error retrieving provider keys.');
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
    }, [navigate, accountKey, currRoleId]);

    const sortByProvider = () => {
        //console.log('sorting name')
        let temp = [...providerKeys]
        temp.sort((a, b) => (a.provider < b.provider) ? -1 : 1)
        setProviderKeys(temp);
    }

    /*
    const sortByDate = () => {
      //console.log('sorting date')
      let temp = [...providerKeys]
      temp.sort((a,b) => (a.created < b.created) ? 1 : -1)
      setProviderKeys(temp);
    }
    */



    return (
        <div>

            {
                (errors.length > 0) ? (
                    <Alert variant='primary'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {
                successMsg !== null ? (
                    <Alert variant='info' className='my-3'>
                        {successMsg}
                    </Alert>
                ) : (null)
            }
            {
                providerKeys.length > 0 ? (
                    <>

                        <Form>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th><span onClick={sortByProvider} role="button">Provider</span></th>
                                        <th><span >Api Key</span></th>
                                        <th><span >Secret Key</span></th>
                                        <th><span >Session Token</span></th>
                                        <th colSpan={2}>actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        providerKeys.map((providerKey, i) => (
                                            <Fragment key={providerKey.providerId}>
                                                <tr >
                                                    <td>{providerKey.provider}</td>
                                                    <td>{maskString(providerKey.apiKey, 4, 12)}</td>
                                                    <td>{maskString(providerKey.secretKey, 4, 12)}</td>
                                                    <td>{maskString(providerKey.sessionToken, 4, 12)}</td>
                                                    <td><Button onClick={() => { showEditForm(i) }} variant='secondary' size='sm' data-toggle="collapse" data-target={`edit-form-${i}`} aria-controls={`edit-form-${i}`}>edit</Button></td>
                                                    <td><Button onClick={() => { deleteProviderKey(providerKey.providerId) }} variant='danger' size='sm'>remove</Button></td>
                                                </tr>    
                                                <tr className='collapse' id={`edit-form-${i}`} >
                                                    <td>{providerKey.provider}</td>
                                                    <td><Form.Control type="text" id={`apiKey-${i}`} defaultValue={providerKey.apiKey} /></td>
                                                    <td>{providerKey.reqSecretKey === 1 ? (<Form.Control type="text" id={`secretKey-${i}`} defaultValue={providerKey.secretKey} />) : null}</td>
                                                    <td>{providerKey.reqSessionToken === 1 ? (<Form.Control type="text" id={`sessionToken-${i}`} defaultValue={providerKey.sessionToken} />) : null}</td>
                                                    <td><Button onClick={() => { saveUpdate(providerKey.providerId, i) }} size='sm'>Save</Button></td>
                                                </tr>
                                            
                                            </Fragment>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </Form>

                    </>
                ) : (
                    null
                )
            }
            {
                showProviderKeyForm ? (
                    <ProviderKeyForm updateProviderKeys={updateProviderKeys} providerKeys={providerKeys} accountKey={accountKey} />
                ) : (
                    null
                )
            }
        </div>
    )
}


export default ProviderKeyList;
